import { createSlice } from "@reduxjs/toolkit";

export const StudentUploadData = createSlice({
  name: "StudentUploadData",
  initialState: {
    currentExamId: "",
    currentQuestionPaperId: "",
    uploadedStudents: [],
    currentExamData: {},
    currentQuestionPaperData: {},
  },
  reducers: {
    setCurrentExamId(state, action) {
      state.currentExamId = action.payload;
    },
    setCurrentQuestionPaperId(state, action) {
      state.currentQuestionPaperId = action.payload;
    },
    setUploadedStudents(state, action) {
      state.uploadedStudents = action.payload;
    },
    setCurrentExamData(state, action) {
      state.currentExamData = action.payload;
    },
    setCurrentQuestionPaperData(state, action) {
      state.currentQuestionPaperData = action.payload;
    },
  },
});

export const {
  setCurrentExamId,
  setCurrentQuestionPaperId,
  setUploadedStudents,
  setCurrentExamData,
  setCurrentQuestionPaperData,
} = StudentUploadData.actions;

export default StudentUploadData.reducer;
